import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { CounterItem } from '../CounterItem';

const CounterWrapper = styled.div`
  position: absolute;
  width: max-content;
  bottom: 30px;
  right: 1%;
  @media (max-width: 1140px) {
    bottom: 15%;
    right: unset;
  }
  float: ${props => props.float};
`;

const counterContent = [
  {
    number: '392',
    title: 'Games'
  },
  {
    number: '27019',
    title: 'Characters'
  },
  {
    number: '101011',
    title: 'Art Assets'
  },
  {
    number: '3128',
    title: 'Earth Days'
  }
];

const Counter = props => (
  <CounterWrapper className='row justify-content-end'>
    {counterContent.map((counterItem, index) => {
      return (
        <CounterItem
          key={index}
          number={Number.parseInt(counterItem.number)}
          title={counterItem.title}
          index={index}
        />
      );
    })}
  </CounterWrapper>
);

Counter.propTypes = {
  sample: PropTypes.bool,
  float: PropTypes.oneOf(['left', 'right'])
};

Counter.defaultProps = {
  sample: false,
  float: 'right'
};

export { Counter };
